import { WarehouseDetailsFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { componentByTypename } from '@/ui/utils/componentByTypename';
import { WarehouseDetailIds } from '@/integrations/crystallize/types/constants';
import { ParsedWarehouseDetails } from '@/integrations/crystallize/types/ParsedWarehouseDetails';

export function parseWarehouseDetails(
  warehouseData?: WarehouseDetailsFragment | null,
): ParsedWarehouseDetails | undefined {
  const parsedDetails: ParsedWarehouseDetails = {};

  const warehouseChunks = componentByTypename(
    warehouseData?.content,
    'ContentChunkContent',
  )?.chunks;
  if (!warehouseChunks) {
    return undefined;
  }

  warehouseChunks[0]?.forEach((chunk) => {
    switch (chunk.id) {
      case WarehouseDetailIds.MinimumDeliveryTime:
        parsedDetails.minimumDeliveryTime = componentByTypename(
          chunk.content,
          'NumericContent',
        )?.number;
        break;
      case WarehouseDetailIds.MaximumDeliveryTime:
        parsedDetails.maximumDeliveryTime = componentByTypename(
          chunk.content,
          'NumericContent',
        )?.number;
        break;
      case WarehouseDetailIds.ExpressMinimumDeliveryTime:
        parsedDetails.expressMinimumDeliveryTime = componentByTypename(
          chunk.content,
          'NumericContent',
        )?.number;
        break;
      case WarehouseDetailIds.ExpressMaximumDeliveryTime:
        parsedDetails.expressMaximumDeliveryTime = componentByTypename(
          chunk.content,
          'NumericContent',
        )?.number;
        break;
      case WarehouseDetailIds.FallbackMinimumDeliveryTime:
        parsedDetails.fallbackMinimumDeliveryTime = componentByTypename(
          chunk.content,
          'NumericContent',
        )?.number;
        break;
      case WarehouseDetailIds.FallbackMaximumDeliveryTime:
        parsedDetails.fallbackMaximumDeliveryTime = componentByTypename(
          chunk.content,
          'NumericContent',
        )?.number;
        break;
      case WarehouseDetailIds.FallbackStockThreshold:
        parsedDetails.fallbackStockThreshold = componentByTypename(
          chunk.content,
          'NumericContent',
        )?.number;
        break;
      case WarehouseDetailIds.OutOfStockThreshold:
        parsedDetails.outOfStockThreshold = componentByTypename(
          chunk.content,
          'NumericContent',
        )?.number;
        break;
      case WarehouseDetailIds.B2CAvailable:
        parsedDetails.b2CAvailable =
          componentByTypename(chunk.content, 'BooleanContent')?.value || false;
        break;
      case WarehouseDetailIds.ProShopAvailable:
        parsedDetails.proShopAvailable =
          componentByTypename(chunk.content, 'BooleanContent')?.value || false;
        break;
      default:
        break;
    }
  });

  return parsedDetails;
}
